module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_38.04b9de4e.png";